import { render } from "./mvt-header.vue?vue&type=template&id=05c78b8c"
import script from "./mvt-header.js?vue&type=script&lang=js"
export * from "./mvt-header.js?vue&type=script&lang=js"

import "./mvt-header.vue?vue&type=style&index=0&id=05c78b8c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__